import { useState } from "react"
import { SIGNUP_URL } from "constants/urls"
import { usePageAssets } from "hooks/usePageAssets"
import ContactSalesModal from "components/ContactSalesModal"
import { openModal } from "utils/openModal"
import Button from "components/ui/Button"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"
import SplitContainer from "components/ui/Layout/SplitContainer"

function HeroSection() {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { getAsset } = usePageAssets()
  const illustration = getAsset("product-hero-illustration")
  return (
    <Container section>
      <SplitContainer
        className="mt-10 lg:-mt-10 lg:pb-16 lg:pt-20 xl:pb-32 xl:pt-40"
        image={illustration}
        imageSize="large"
        imageClassName="scale-150 md:scale-125 xl:scale-100 lg:translate-x-[7%] xl:translate-x-[10%] 2xl:translate-x-[5%] mt-[25%] md:mt-0 lg:mt-10"
      >
        <Heading
          level="h1"
          label="Deploy Anywhere"
          title="Open analytics that runs on your terms"
          subtitle="Preset is a fully-managed open analytics platform built on Apache Superset™ — available as SaaS, in your private cloud, or fully on-prem. One platform, every deployment model."
          size="huge"
          narrow
        />
        <div className="mt-7 flex flex-col gap-4 sm:flex-row">
          <Button
            color="green"
            size="medium"
            href={SIGNUP_URL}
            trackClick="Get started (hero)_Deploy Anywhere"
            shadow
          >
            Get started free
          </Button>
          <Button
            color="catskill-white"
            size="medium"
            href="/contact-sales/"
            onClick={openModal(setIsModalOpen)}
            trackClick="Talk to an Expert (hero)_Deploy Anywhere"
          >
            Talk to an Expert
          </Button>
        </div>
      </SplitContainer>
      <ContactSalesModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        sourcePage="deploy-anywhere-hero"
      />
    </Container>
  )
}

export default HeroSection
